import { render } from "./EditUser.vue?vue&type=template&id=725a362e&ts=true"
import script from "./EditUser.vue?vue&type=script&lang=ts"
export * from "./EditUser.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\YellowBeardProject\\dobby\\dobbyshopadmin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__